import type { CommandInternal, CommandSections } from '../../../../common/types/commands/index.tsx';
import { SEARCH_SECTION_PRIORITY_OFFSET_STRENGTH } from './constants.tsx';

const getSectionOffset = <T extends { priority?: number }>(section: T) =>
	1 + (section.priority ?? 0) * SEARCH_SECTION_PRIORITY_OFFSET_STRENGTH;

export const sortCommands = (
	commands: CommandInternal[],
	selectedSections?: CommandSections,
): CommandInternal[] => {
	const sortByPriority = (commandsToSort: CommandInternal[]) =>
		commandsToSort.sort((a, b) => (a.priority || 0) - (b.priority || 0));

	const sortedSections = Object.entries(selectedSections ?? {}).sort(([idA, valA], [idB, valB]) => {
		const aScore =
			Math.min(
				...commands
					.filter((command) => command.section === idA)
					.map((command) => command.searchRelevancyScore ?? 1),
				1,
			) * getSectionOffset(valA);
		const bScore =
			Math.min(
				...commands
					.filter((command) => command.section === idB)
					.map((command) => command.searchRelevancyScore ?? 1),
				1,
			) * getSectionOffset(valB);
		if (aScore !== bScore) {
			return aScore - bScore;
		}

		const priorityA = valA.priority || 0;
		const priorityB = valB.priority || 0;

		return priorityA - priorityB;
	});
	return sortByPriority(commands).sort((a, b) => {
		if (a.section && !b.section) {
			return 1;
		}
		if (!a.section && b.section) {
			return -1;
		}
		if (a.section === b.section) {
			return (a.searchRelevancyScore ?? 1) - (b.searchRelevancyScore ?? 1);
		}
		return (
			sortedSections.findIndex(([id]) => id === a.section) -
			sortedSections.findIndex(([id]) => id === b.section)
		);
	});
};
